export default "__VITE_ASSET__BWlsaebA__"